import React, { useState } from 'react'
import emailjs from '@emailjs/browser';
import { emailJsInfo } from '../Data/emailjsConfig';

export default function Contact() {
  const [contactmeForm, setContactmeForm] = useState({
    name: '',
    email: '',
    message: ''
  })
  const [buttonMessage, setButtonMessage] = useState('Send Message')

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setContactmeForm({
      ...contactmeForm,
      [e.target.name]: e.target.value
    })
  }

  const inputChecker = (): boolean => {
    return contactmeForm.name !== '' && contactmeForm.email !== '' && contactmeForm.message !== ''
  }

  const sendMail = (): void => {
    if (!inputChecker()) return;

    emailjs.send(
      emailJsInfo.service_id,
      emailJsInfo.template_id,
      {
        from_name: contactmeForm.email,
        email_subject: "from personal site " + contactmeForm.email,
        message: contactmeForm.message,
        reply_to: "abrahamterfie4563@gmail.com",
      },
      emailJsInfo.public_key
    ).then(() => {
      setButtonMessage('Message sent!')
      setContactmeForm({ name: '', email: '', message: '' })
    }, () => {
      setButtonMessage('Message not sent. Try again.')
    });
  }

  return (
    <div>
      <h2>Contact Me</h2>

      <p>If you have any questions or want to work with me, feel free to reach out.</p>

      <p>
        <b>Email:</b> <a href="mailto:abrahamterfie4563@gmail.com">abrahamterfie4563@gmail.com</a>
      </p>

      <hr />

      <h3>Send a Message</h3>

      <form onSubmit={(e) => { e.preventDefault(); sendMail(); }}>
        <p>
          <label htmlFor="name"><b>Name:</b></label><br />
          <input
            type="text"
            name="name"
            id="name"
            value={contactmeForm.name}
            onChange={handleChange}
            style={{ width: '100%', maxWidth: '400px' }}
          />
        </p>

        <p>
          <label htmlFor="email"><b>Email:</b></label><br />
          <input
            type="email"
            name="email"
            id="email"
            value={contactmeForm.email}
            onChange={handleChange}
            style={{ width: '100%', maxWidth: '400px' }}
          />
        </p>

        <p>
          <label htmlFor="message"><b>Message:</b></label><br />
          <textarea
            name="message"
            id="message"
            value={contactmeForm.message}
            onChange={handleChange}
            rows={8}
            style={{ width: '100%', maxWidth: '400px' }}
          />
        </p>

        <p>
          <button
            type="submit"
            disabled={!inputChecker()}
            style={{
              padding: '8px 20px',
              cursor: inputChecker() ? 'pointer' : 'not-allowed',
              opacity: inputChecker() ? 1 : 0.5
            }}
          >
            {buttonMessage}
          </button>
        </p>
      </form>
    </div>
  )
}
